import React, { useState, useEffect, useRef } from "react";
import { Col, Container, Modal, Row, Button, Form, Spinner} from 'react-bootstrap';
import { useSelector } from "react-redux";
import GridControl from '../Controls/gridControl';
import APICom from '../../utils/helpers/APICom';
import Table from 'react-bootstrap/Table';
import * as XLSX from 'xlsx';
import ExportIcon from "../../assets/Images/CommonImages/save.png";
import ClearFilterIcon from "../../assets/Images/CommonImages/clearFilter.png";
import MapControlSkeleton from "../Controls/mapControlSkeleton";
import checkMark from "../../assets/Images/CommonImages/checkMark.png";
import { Icon } from "@iconify/react";

const AgileDispatch = (props) => {

    const { GlobalASCSData }  = useSelector((store) => store.combinedata);
    const [showAgileDispatchDialog, setShowAgileDispatchDialog] = useState(false);
    const [displayNoDataAlert, setDisplayNoDataAlert] = useState(false);
    const [noDataAlert, setNoDataAlert] = useState({ alertTitle: '', alertMsg: '', btnFlag: true, ShowYesNoBtn: false });
    const [showLoader, setShowLoader] = useState(false);
    const [showSharedLinkConfirmation, setShowSharedLinkConfirmation] = useState(false);
    const [customerPhone, setCustomerPhone] = useState(0);
    const linkShareHTMLRef = useRef(null);
    const [showShareLink, setShowShareLink] = useState(false);
    const [confirmationNo, setConfirmationNo] = useState('');
    const [puPerson, setPuPerson] = useState('');
    const [puDateTime, setPuDateTime] = useState('');
    const [puZone, setPuZone] = useState('');
    const [doZone, setDoZone] = useState('');
    const [puAddr, setPuAddr] = useState('');
    const [doAddr, setDoAddr] = useState('');
    const [assignedVehicle, setAssignedVehicle] = useState('');
    const [assignedDriver, setAssignedDriver] = useState('');
    const [tripStatus, setTripStatus] = useState('');
    const [AgileStatus, setAgileStatus] = useState("");
    const [TSPID, setTSPID] = useState("0");
    const [ExpansionCount, setExpansionCount] = useState(0);

    const [ComponentAliveTestCounter, setComponentAliveTestCounter] = useState(0);
    const refTimerID = useRef(null);

    const [AllowAgileRequestSend, setAllowAgileRequestSend] = useState(true);

    const [serviceid, setServiceid] = useState(-1);
    const [PUTime, setPUTime] = useState("");
    const [mapArr, setMapArr] = useState([]);

    const xCancelSourceForGrid = useRef(null);

    const [ShowGridLoader, setShowGridLoader] = useState(false);
    const [AgileDispatchGridResponse, setAgileDispatchGridResponse] = useState([]);
    const [AgileDispatchGridControlOptions, SetAgileDispatchOptions] = useState({
        height: '300',
        pagination: true,
        paginationMode: "local",
        paginationSize: 20,
        paginationSizeSelector: [20, 40, 60, 80, 100],
        selectable: false,
        reactiveData: true, //enable data reactivity
        layout: "fitDataStretch",
        placeholder: "No Data Available",
        selectableRangeMode: "click",
        GridName: "agileDispatchGrid",
        paginationCounter: "rows",
        movableColumns: true,
        vDefaultGridName: "AgileDispatch_grdControl",
        bSysUser: 1,
        intervalEnable: true,
        bWebApplySettingToAll: true,
        ID_Column: "iDriverID",
        GridReturnOnlyIDColumnInRowData: false,
        reactiveData: false
    });

    const agileDispatchTableObj = useRef(null);

    //---------------------------------------------------Agile Dispatch Table------------------------------------------------------
    const [agileDispatchOptions, setAgileDispatchOptions] = useState({
        height: 300,
        heightoffset: 600,
        calculateHeight: true,
        pagination: true,
        sortCondition: true,
        mapZoomOpts: {zoomControl: false, draggable: true, scrollWheel: true, disableDoubleClickZoom: false},
        mapDefaultBtns: false,
        mapPolylines:{single:true,multiple:false},
        mapOptions: {tilt: 47.5, zoom: 15, zone:false},
        paginationMode: "local",
        //paginationSize: [500, 1000, 2000],
        selectable: 1,
        reactiveData:false, //enable data reactivity
        layout: "fitColumns",
        placeholder:"No Data Available",
        clipboard: false,
        selectableRangeMode: "click",
        GridName:"agileDispatch",
        paginationCounter:"rows",
        intervalTimer: GlobalASCSData.find(dict => dict.SubTitle === "Tb01") === undefined? 60000:GlobalASCSData.find(dict => dict.SubTitle === "Tb01").value*2000,
        movableColumns:true,
        vDefaultGridName: "SelectedGridRouteSRQARQPRQ_New",
        index: "VehNo",
        autoColumns: true,
        bSysUser: 1,
        intervalEnable: false,
        persistence: false,
        bWebApplySettingToAll: true,
        GridReturnOnlyIDColumnInRowData: false,
        containerClass: "col position-relative",
        Containerstyle: {},
        footerElement: '<button class="tabulator_btns" title="Export Excel" id="'
        +"agileDispatch"+'_Export"></button><button class="tabulator_btns lastTabulator-btn" title="Clear Filters" id="'+"agileDispatch"+'_ClearFilter"></button>',
        tableDoubleClickFunc: function(table, row) {
        },
        footerElementHandles: function (table) {
            agileDispatchTableObj.current = table;
            // agileDispatchTableObj.current.selectRow( agileDispatchTableObj.current.getData()[0].VehNo);
            var img = document.createElement("img");
                img.style.cssText = "width:16px; height:16px;"; 
                img.src = ExportIcon;
                document.getElementById("agileDispatch_Export").appendChild(img);

            img = document.createElement("img");
                img.style.cssText = "width:16px; height:16px;"; 
                img.src = ClearFilterIcon;
                document.getElementById("agileDispatch_ClearFilter").appendChild(img);

            document.getElementById("agileDispatch_Export").addEventListener("click", function(){
                const data = table.getData('active');
                const columnsToIgnore = ['id'];
                var filteredData = data.map(row =>{
                    const filteredRow = {...row};
                    columnsToIgnore.forEach(column => delete filteredRow[column]);
                    return filteredRow;
                });
                
                const sheet = XLSX.utils.json_to_sheet(filteredData);
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, sheet, "Agile Dispatch Data");
                XLSX.writeFile(wb, "agileDispatch_data.xlsx");
                
            });
            document.getElementById("agileDispatch_ClearFilter").addEventListener("click", function(){
                table.clearHeaderFilter();
            });
        },
        rowSelectionChangeHandle: function(data){ 
            try{
                // console.log("Row selection changed!");
            }
            catch(err){console.log(err);}
        },
        AlwaysHiddenColumns: ["IsAgileTrip", "VehicleBidRank", "ServiceStatusID", "LastResponseTime", "AssignedVehicleNo", "AssignedDriver"],
        customWidthCols: ["TripRequestStatus-300", "OfferStatus-200", "DispatchTime-270"]
    });
    useEffect(() => {
        // console.log("Agile Dispatch invoked");
        const rowData = props.GridRowData;
        // console.log("$$%%$$ rowData $$%%$$", rowData);

        if (!rowData || rowData.length !== 1) {
            // No trip selected or multiple trips selected
            setNoDataAlert({
                alertTitle: !rowData ? 'No trip selected' : 'Multiple trips selected',
                alertMsg: !rowData ? 'Please select a trip for agile dispatch action.' : 'Please select one trip for agile dispatch action.',
                btnFlag:true, ShowYesNoBtn: false
            });
            setDisplayNoDataAlert(true);
            setShowAgileDispatchDialog(false);
            // props.setShowAgileDispatch(false);
        } else {
            const gData = rowData[0];
            setPUTime(gData.PickupTime);
            setConfirmationNo(gData["ConfirmationNo"]);
            setPuPerson(gData["PickupPerson"]);
            setPuDateTime(gData["PickupDateTime"]);
            setPuZone(gData["PZONE"]);
            setDoZone(gData["DZONE"]);
            setPuAddr(gData["PickupAddress"]);
            setDoAddr(gData["Destination"]);
            setAssignedVehicle(gData["VEHNo"]);
            setAssignedDriver(gData["AssignedDriver"]);
            setTripStatus(gData["TripRequestStatus"]);
            setServiceid(parseInt(gData["ServiceID"]));
            setCustomerPhone(gData.Phone);
            setTSPID(String(gData.iSRATSPID));
            if(gData.ServiceStatus?.toUpperCase() === "DISPATCHED" || gData.ServiceStatus?.toUpperCase() === "ASSIGNED" || gData.ServiceStatus.toUpperCase() === "DROPPED" || gData.ServiceStatus.toUpperCase() === "IRTPU" || gData.ServiceStatus.toUpperCase() === "PICKEDUP" || gData.ServiceStatus.toUpperCase() === "ATLOCATION")
            {
                setNoDataAlert({
                    alertTitle: "Agile Dispatch Qualification Alert",
                    alertMsg: 'Trip is not qualifying for the Agile Dispatch, it is already Dispatched.',
                    btnFlag:true, ShowYesNoBtn: false
                });
                setDisplayNoDataAlert(true);
                setShowAgileDispatchDialog(false);
                // props.setShowAgileDispatch(false);
            }
            else
            {
                setShowAgileDispatchDialog(true);
            }
            
        }
        return () => {
            try{
                if(refTimerID.current != null){
                    clearTimeout(refTimerID.current);
                }
            }
            catch(e){

            }
        }
    }, [props.GridRowData, GlobalASCSData]);

    useEffect(() => {
        if(serviceid > 0){
            
            PrepareGridRequest();
            //TestIfComponentAlive();
        }
    }, [serviceid]);

    const handleAgileDispatch = ()=>{
        console.log("reloading");
    };
    var ExpansionCountR = 0
    const ExpandSearch = () =>{
        if(ExpansionCount === 0 && ExpansionCountR === 0){
            ExpansionCountR = ExpansionCountR + 1;
            setExpansionCount(1);
            setAgileStatus("Agile dispatch concluded. Expanding search!");
            SendAgileRequest("Force Expansion");
        }
    }

    const PrepareGridRequest = async () => {
        //setShowGridLoader(false);
        xCancelSourceForGrid.current = APICom.GenerateSource();
        const data = {
            "iServiceID": serviceid
        };
        setAllowAgileRequestSend(false);
        let gData = props.GridRowData[0];
        if(gData?.ServiceStatus.toUpperCase() === "ACTIVE" || gData?.ServiceStatus.toUpperCase() === "ASSIGNED" || gData?.ServiceStatus.toUpperCase() === "TRANSFERRED")
        {
            let nearbyVehData = {
                "pulat": gData?.PickupLatitude,
                "pulong": gData?.PickupLongitude,
                "nwheelchairs": String(gData?.nTotalWheelChairs),
                "iatspid": String(gData?.iSRATSPID),
                "bshowoccupiedvehicles": "false",
                "irefid": String(gData?.iRefID),
            };
            
            let mapArr = [{lat:parseFloat(gData.PickupLatitude),lng: parseFloat(gData.PickupLongitude), Type:"PU", name:gData.PickupPerson, address:gData.PickupAddress},
            {lat:parseFloat(gData.DropLatitude),lng: parseFloat(gData.DropLongitude), Type:"DO", name:gData.PickupPerson, address:gData.Destination}];
            // setMapArr(mapArr);
            await APICom.fetchData("main", "TripActions/getnearbyvehicles", "post", {}, nearbyVehData, xCancelSourceForGrid.current).then((response) => {
                if(response.data.length > 0)
                {
                    let vehData = [];
                    for(let j = 0; j < response.data.length; j++)
                    {
                        if(parseInt(response.data[j].Distance) < 20)
                        {
                            vehData.push({lat:parseFloat(response.data[j].LATITUDE),lng: parseFloat(response.data[j].LONGITUDE), VehInfo:(response.data[j].VehMake +" "+response.data[j].VehicleMake),
                                State: response.data[j].STATE, Type:"Vehicle", VehNo:response.data[j].VehNo, DriverNo:response.data[j].DriverNo, Distance:response.data[j].Distance});
                        }
                    }
                    // console.log([...mapArr,...vehData]);
                    setMapArr([...mapArr,...vehData]);
                }
                else
                {
                    setMapArr(mapArr);
                }
            });

        }
        APICom.fetchData("main", "TripActions/GetAgileDispatchStatus", "post", {}, data, xCancelSourceForGrid.current).then((response) => {
            setShowGridLoader(false);
            if (response.error === "") {
                setAgileDispatchGridResponse(response.data);
                try{
                    if(response.data.length > 0) {
                        setAssignedVehicle(response.data[0]["AssignedVehicleNo"]);
                        setAssignedDriver(response.data[0]["AssignedDriver"]);
                        setTripStatus(response.data[0]["TripRequestStatus"]);
                    }
                }
                catch(op) { }
                let ServiceStatusNoneOrAssigned = false;
                try{
                    if(response.data.length > 0 && (response.data[0]["ServiceStatusID"] == 1 || response.data[0]["ServiceStatusID"] == 2)){
                        ServiceStatusNoneOrAssigned = true;
                    }
                }
                catch(op) { }
                if(response.data.length == 0 || response.data[0]["VehNo"] == ""){
                    //SendAgileRequest();
                    if(response.data.length == 0 || ServiceStatusNoneOrAssigned){
                        setAllowAgileRequestSend(true);
                        setAgileStatus("Agile dispatch initiated.");
                        SendAgileRequest(null);
                    }
                    else{
                        if(response.data && response.data.length > 0)
                        {
                            setAllowAgileRequestSend(false);
                            setAgileStatus("" + response.data[0]["TripRequestStatus"]);
                        }
                        else
                        {
                            setAllowAgileRequestSend(false);
                            setAgileStatus("");
                        }
                    }
                }
                else{
                    let DispatchStatusExist = false;
                    response.data.forEach(element => {
                        if(element["OfferStatus"] == "DISPATCHED" || element["OfferStatus"] == "TRIPOFFERED"){
                            DispatchStatusExist = true;
                        }
                    });
                    if(DispatchStatusExist == true){
                        setAllowAgileRequestSend(false);
                        setAgileStatus("Agile dispatch is already in progress.");
                        refTimerID.current = setTimeout(() => {
                            UpdateAgileDispatchStatus();
                        }, 5000);
                    }
                    else{
                        setAllowAgileRequestSend(true);
                        setAgileStatus("Agile dispatch concluded.");
                        // setAgileStatus("Agile dispatch concluded. Expanding search!");
                        // SendAgileRequest("Force Expansion");
                        //ExpandSearch();
                    }
                }
            }
        });

    }
    const TestIfComponentAlive = async () => {
        console.log("Component alive: "+ ComponentAliveTestCounter.toString());
        setComponentAliveTestCounter(ComponentAliveTestCounter + 1);
        refTimerID.current = setTimeout(TestIfComponentAlive, 3000);
    }
    const UpdateAgileDispatchStatus = async () => {
        //setShowGridLoader(false);
        xCancelSourceForGrid.current = APICom.GenerateSource();
        const data = {
            "iServiceID": serviceid
        }
        setAllowAgileRequestSend(false);
        APICom.fetchData("main", "TripActions/GetAgileDispatchStatus", "post", {}, data, xCancelSourceForGrid.current).then((response) => {
            setShowGridLoader(false);
            if (response.error === "") {
                setAgileDispatchGridResponse(response.data);
                try{
                    if(response.data.length > 0){
                        setAssignedVehicle(response.data[0]["AssignedVehicleNo"]);
                        setAssignedDriver(response.data[0]["AssignedDriver"]);
                        setTripStatus(response.data[0]["TripRequestStatus"]);
                    }
                }
                catch(op) { }
                let ServiceStatusNoneOrAssigned = false;
                try{
                    if(response.data.length > 0 && (response.data[0]["ServiceStatusID"] == 1 || response.data[0]["ServiceStatusID"] == 2)){
                        ServiceStatusNoneOrAssigned = true;
                    }
                }
                catch(op) { }
                if(response.data.length == 0 || response.data[0]["VehNo"] == ""){
                    refTimerID.current = setTimeout(() => {
                        UpdateAgileDispatchStatus();
                    }, 5000);
                    if(response.data.length == 0 || ServiceStatusNoneOrAssigned){
                        setAllowAgileRequestSend(true);
                        setAgileStatus("Please initiate agile dispatch.");
                    }
                    else{
                        setAllowAgileRequestSend(false);
                        setAgileStatus("" + response.data[0]["TripRequestStatus"]);
                        if(response.data[0]["TripRequestStatus"].toUpperCase() === "ACCEPTED")
                        {
                            setShowShareLink(false);
                            setShowSharedLinkConfirmation(false);
                            let newAlertMessageHTML =
                                <Row className="w-100 m-0">
                                    <Col className="text-center"> 
                                        <img src={checkMark} />
                                        <p className="m-0 mt-2 small text-start">
                                            {"Trip is dispatched to driver number "}
                                            <span className="fw-bold">{response.data[0].DrvNo}</span>
                                            {", driving vehicle "}<span className="fw-bold">{response.data[0].VehNo}</span>
                                            {", on the way to rider's location."}
                                        </p>
                                        <Button ref={linkShareHTMLRef} onClick={handleShareLinkClick} className="activate_btn_ok border-0 mt-2">
                                            <Icon icon="bx:share-alt" className='d-inline-flex mx-1' style={{color:"black"}}/> 
                                            {"Share Tracking Link"}
                                        </Button>
                                    </Col>
                                </Row>;
                            setNoDataAlert({
                                alertTitle: "Agile Dispatch Alert",
                                alertMsg: newAlertMessageHTML,
                                btnFlag:false, ShowYesNoBtn: false
                            });
                        }
                        
                    }
                }
                else{
                    let DispatchStatusExist = false;
                    response.data.forEach(element => {
                        if(element["OfferStatus"] == "DISPATCHED" || element["OfferStatus"] == "TRIPOFFERED"){
                            DispatchStatusExist = true;
                        }
                    });
                    if(DispatchStatusExist == true){
                        setAllowAgileRequestSend(false);
                        setAgileStatus("Agile dispatch in progress.");
                        refTimerID.current = setTimeout(() => {
                            UpdateAgileDispatchStatus();
                        }, 5000);
                    }
                    else{
                        if(ServiceStatusNoneOrAssigned){
                            setAllowAgileRequestSend(true);
                        }
                        setAgileStatus("Agile dispatch concluded.");
                        if(response.data[0]["TripRequestStatus"] == "ACCEPTED" || response.data[0]["TripRequestStatus"] == "IRTPU" || response.data[0]["TripRequestStatus"] == "ATLOCATION"){
                            setNoDataAlert({
                                alertTitle: "Agile Dispatch Alert",
                                alertMsg: "Trip is accepted by Vehicle " + response.data[0]["AssignedVehicleNo"] + ", do you want to close Agile Window?",
                                btnFlag: false, ShowYesNoBtn: true
                            });
                            setDisplayNoDataAlert(true);
                        }
                        // else if(ServiceStatusNoneOrAssigned) {
                        //     setAgileStatus("Agile dispatch concluded. Expanding search!");
                        //     SendAgileRequest("Force Expansion");
                        // }
                    }
                }
            }
            else{
                refTimerID.current = setTimeout(() => {
                    UpdateAgileDispatchStatus();
                }, 5000);
            }
        });

    }

    const handleShareLinkClick =()=>{
        try{
            setShowShareLink(true);
            linkShareHTMLRef.current.className =  "d-none activate_btn_ok border-0";
        }
        catch(err){console.log(err);}
    };

    const SendAgileRequest = async (e) => {
        //setShowGridLoader(false);
        setAgileStatus("");
        let expantionmode = false;
        if(e != null)
        {
            expantionmode = true;
        }
        xCancelSourceForGrid.current = APICom.GenerateSource();
        const data = {
            "iServiceID": serviceid,
            "ExpantionMode": expantionmode
        }
        setAllowAgileRequestSend(false);
        APICom.fetchData("main", "TripActions/AgileDispatch", "post", {}, data, xCancelSourceForGrid.current).then((response) => {
            setShowGridLoader(false);
            setAllowAgileRequestSend(true);
            if (response.error === "") {
                //alert(response.data[0]["Msg"])
                let msg = "Agile performed successfully."
                try{
                    msg = response.data[0]["Msg"];
                }
                catch(op){}
                setAgileStatus(msg);

                
                // if(msg.indexOf("success") > -1) {
                //     setShowShareLink(false);
                //     setShowSharedLinkConfirmation(false);
                //     let newAlertMessageHTML =
                //         <Row className="w-100 m-0">
                //             <Col className="text-center"> 
                //                 <img src={checkMark} />
                //                 <p className="m-0 mt-2 small text-start">
                //                     {"Trip is dispatched to driver number "}
                //                     <span className="fw-bold">{response.data[0].DrvNo}</span>
                //                     {", driving vehicle "}<span className="fw-bold">{response.data[0].VehNo}</span>
                //                     {", on the way to rider's location."}
                //                 </p>
                //                 <Button ref={linkShareHTMLRef} onClick={handleShareLinkClick} className="activate_btn_ok border-0 mt-2">
                //                     <Icon icon="bx:share-alt" className='d-inline-flex mx-1' style={{color:"black"}}/> 
                //                     {"Share Tracking Link"}
                //                 </Button>
                //             </Col>
                //         </Row>;
                //     setNoDataAlert({
                //         alertTitle: "Agile Dispatch Alert",
                //         alertMsg: newAlertMessageHTML,
                //         btnFlag:false, ShowYesNoBtn: false
                //     });    
                // }
                // else
                // {
                    setNoDataAlert({
                        alertTitle: "Agile Dispatch Alert",
                        alertMsg: msg,
                        btnFlag:true, ShowYesNoBtn: false
                    });
                // }
                
                setDisplayNoDataAlert(true);
                if(msg.indexOf("success") > -1) {
                    UpdateAgileDispatchStatus();
                }
                else{
                    setAllowAgileRequestSend(true);
                    //setAgileStatus("Agile dispatch concluded. Expanding search!");
                    //SendAgileRequest("Force Expansion");
                    //ExpandSearch();
                }
            }
        });

    }
    
    const UnMountAgileDispatchComponent = () => {
        props.UnMountFunction();
        // if(props.showAgileDispatch)
        //   {
        //     props.setShowAgileDispatch(false);
        //   }
    }

    const handleAgileDispatchDialogClose = () => {
        try {
            setShowAgileDispatchDialog(false);
            props.setShowAgileDispatch(false);
            UnMountAgileDispatchComponent();
        } catch (err) {
            console.log(err);
        }
    }

    const handleAlertModalClose = () => {
        if(noDataAlert.alertTitle.toLowerCase().includes("no trip") ||  noDataAlert.alertTitle.toLowerCase().includes("multiple") 
            || noDataAlert.alertTitle.toLowerCase().includes("qualification"))
        {
            setDisplayNoDataAlert(false);
            props.setShowAgileDispatch(false);
        }
        else if(noDataAlert.alertMsg.toLowerCase().includes("no nearby")){
            ExpandSearch();
            setDisplayNoDataAlert(false);
        }
        else
        {
            setDisplayNoDataAlert(false);
        }
        //UnMountAgileDispatchComponent();


    }

    const handleSendShareLinkToCustomer = ()=>{
        try{
            xCancelSourceForGrid.current = APICom.GenerateSource();
            const data = {
                "confirmationno": confirmationNo,
                "phoneno": customerPhone
            }
            APICom.fetchData("main", "TripActions/sendTripTrackingLinkToCustomer", "post", {}, data, xCancelSourceForGrid.current).then((response) => {
                if (response.error === "" && response.data && response.data.toLowerCase().includes("success")) {

                    setShowSharedLinkConfirmation(true);
                }
            });
    
            
        }
        catch(err){console.log(err);}
    };

    const tableSelRows = () => {

    }
    const setTableRowsSel = () => {

    }
    
    const setMapView = () => {

    }
    const MapDetailData = () => {

    }
    const GridRowSelect = () => {

    }
    const GridRowDoubleClick = () => {

    }

    return (
        <>
            {showAgileDispatchDialog ?
                <Modal centered show={showAgileDispatchDialog} onHide={handleAgileDispatchDialogClose} backdrop="static" keyboard={true} animation={true}  size="xl">
                    <Modal.Header className='activate_dialog_header_bgcolor' style={{ height: "50px" }} closeButton>
                        <Modal.Title className='activate_dialog_title_color user-select-none'>{"Agile Dispatch"}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="grid-example user-select-none">
                        <Row className="m-0">
                            <Col>
                                <Row>
                                    <Col>
                                        <Row>
                                            <Col>
                                                <Container className="border rounded float-start w-100 d-flex mt-1" style={{backgroundColor:"#e6eef1"}} title={puPerson}>
                                                    <Icon icon="bx:user"  className='float-start d-inline-flex' style={{color:"#32728b", height:"30px"}}/>
                                                    <p className="m-0 overflow-hidden text-nowrap py-1 mx-1 small float-end" style={{textOverflow:"ellipsis", width:"150px"}}>
                                                        {puPerson}
                                                    </p>
                                                </Container>
                                                <Container className="border rounded float-start mt-1 w-100" style={{backgroundColor:"#e6eef1"}} title={"Pickup Date"}>
                                                    <Icon icon="bx:calendar"  className='' style={{color:"#32728b", height:"30px"}}/>
                                                    <p className="m-0 py-1 mx-1 d-inline-flex small">{puDateTime.split(" ")[0]}</p>
                                                </Container>
                                            </Col>
                                            <Col>
                                                <Container className="border rounded w-100 mt-1" style={{backgroundColor:"#e6eef1"}} title={"Rider Confirmation Number"}>
                                                    <Icon icon="bx:been-here"  className='' style={{color:"#32728b", height:"30px"}}/>
                                                    <p className="m-0 py-1 mx-1 overflow-hidden text-nowrap d-inline-flex small" style={{textOverflow:"ellipsis", width:"150px"}} title={"Rider Confirmation #: "+confirmationNo}>{confirmationNo}</p>
                                                </Container>
                                                
                                                <Container className="border rounded mt-1 w-100" style={{backgroundColor:"#e6eef1"}} title={"Pickup Time"}>
                                                    <Icon icon="bx:time"  className='' style={{color:"#32728b", height:"30px"}}/>
                                                    <p className="m-0 py-1 mx-1 d-inline-flex small">{PUTime}</p>
                                                </Container>
                                            </Col>
                                        </Row>
                                        <Row className="m-0 mt-1 overflow-auto w-100">

                                            <Col className="p-0 mx-1">
                                                <Row className="d-flex w-100">
                                                    <Col xs={1} className="text-end p-0">
                                                        <Icon icon="bx:target-lock" className='d-inline-flex mt-1' style={{color:"#32728b"}}/>
                                                    </Col>
                                                    <Col xs={8}>
                                                        <p className="m-0 p-1 w-100 border rounded small overflow-hidden text-nowrap" title={"Pickup Address: "+puAddr} style={{backgroundColor:"#e6eef1",textOverflow:"ellipsis"}}>{puAddr}</p>
                                                    </Col>
                                                    <Col xs={3} className="p-1 border fw-bold rounded d-flex" style={{fontSize:"small", backgroundColor:"#e6eef1", textOverflow:"ellipsis"}} title={"Pickup Zone: "+puZone}>
                                                        <Icon icon="bx:map-alt"  className='p-0 mt-1' style={{color:"#32728b"}}/>
                                                        <p className="m-0 mx-1 text-nowrap overflow-hidden small" style={{textOverflow:"ellipsis"}}>{puZone}</p>
                                                    </Col> 
                                                </Row>
                                                <Row className="d-flex mt-1 w-100">
                                                    <Col xs={1} className="text-end p-0">
                                                        <Icon icon="bx:map" className='d-inline-flex mt-1' style={{color:"#32728b"}}/>
                                                    </Col>
                                                    <Col xs={8}>
                                                        <p className="m-0 p-1 w-100 border rounded small overflow-hidden text-nowrap" title={"Dropoff Address: "+doAddr} style={{backgroundColor:"#e6eef1",textOverflow:"ellipsis"}}>{doAddr}</p>
                                                    </Col>
                                                    <Col xs={3} className="p-1 border fw-bold rounded d-flex" style={{fontSize:"small", backgroundColor:"#e6eef1",textOverflow:"ellipsis"}} title={"Dropoff Zone: "+doZone}>
                                                        <Icon icon="bx:map-alt"  className='p-0 mt-1' style={{color:"#32728b"}}/>
                                                        <p className="m-0 mx-1 text-nowrap overflow-hidden small" style={{textOverflow:"ellipsis"}}>{doZone}</p>
                                                    </Col>
                                                </Row>
                                            </Col>

                                        </Row>
                                        <Row className="m-0 mt-1">
                                            <Col className="d-block">
                                                <Row className="w-100">
                                                    <p className="text-center text-danger small mt-2">{AgileStatus == ""? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden={true} /> : AgileStatus}</p>
                                                </Row>
                                                <Row>
                                                    <Col className="d-flex justify-content-center">
                                                        {AllowAgileRequestSend? 
                                                            <Button onClick={SendAgileRequest} className="activate_btn_ok border-0"  value="Send Agile Offers">
                                                                <Icon icon="bx:expand" className='d-inline-flex mx-1' style={{color:"black"}}/> 
                                                                {"Expand Search"}
                                                            </Button>
                                                        : <Button onClick={SendAgileRequest}  value="Send Agile Offers" disabled={true}> 
                                                            {"Send Agile Offer"}
                                                        </Button>}
                                                        
                                                    </Col>  
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Col>
                    
                                    
                                </Row>
                            </Col>
                            <Col className="border border-secondary rounded p-0">
                                <MapControlSkeleton options={agileDispatchOptions} MapDetailData={mapArr}/>
                            </Col>
                        </Row>
                        {AgileDispatchGridResponse.length > 0 ? <Row className="m-0 mt-3">
                            <GridControl ShowLoader={showLoader} ReloadDataFunction={handleAgileDispatch} Data={AgileDispatchGridResponse} options={agileDispatchOptions}/>
                        </Row>:""}
                        {/* <Container>
                            <Row>
                                <Col>
                                    <Form.Label><b>Conf. #: </b>{confirmationNo}</Form.Label>
                                </Col>
                                <Col>
                                    <Form.Label><b>PU Person: </b>{puPerson}</Form.Label>
                                </Col>
                                <Col>
                                    <Form.Label><b>PU Date: </b>{puDateTime}</Form.Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Label><b>Assigned Vehicle: </b>{assignedVehicle}</Form.Label>
                                </Col>
                                <Col>
                                    <Form.Label><b>Assigned Driver: </b>{assignedDriver}</Form.Label>
                                </Col>
                                <Col>
                                    <Form.Label><b>Trip Status: </b>{tripStatus}</Form.Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Label><b>PU Zone: </b>{puZone}</Form.Label>
                                </Col>
                                <Col>
                                    <Form.Label><b>DO Zone: </b>{doZone}</Form.Label>
                                </Col>
                                <Col>
                                {AllowAgileRequestSend? (<Button onClick={SendAgileRequest}  value="Send Agile Offers"> Expand</Button>) 
                                : (<Button onClick={SendAgileRequest}  value="Send Agile Offers" disabled={true}> Send Agile Offer</Button>)}
                                
                                </Col>
                            </Row>
                            <Row>
                                <Form.Label><b>PU Address: </b>{puAddr}</Form.Label>
                            </Row>
                            <Row>
                                <Form.Label><b>DO Address: </b>{doAddr}</Form.Label>
                            </Row>
                            <Row>
                                <Form.Label><b>Agile Status: </b>{AgileStatus == ""? (<Spinner as="span" animation="border" size="sm" role="status" aria-hidden={true} />) : AgileStatus}</Form.Label>
                            </Row>
                            <Form.Group className="mb-3"> */}
                                {/* <GridControl 
                                    persistentRowsSel={tableSelRows} setPersistentRowSelection={setTableRowsSel} handleMapMode={setMapView} MapDetailData={MapDetailData} setSelectedRowData={GridRowSelect} GridRowDoubleClick={GridRowDoubleClick}
                                    Data={AgileDispatchGridResponse} ReloadDataFunction={PrepareGridRequest} options={AgileDispatchGridControlOptions} ShowLoader={ShowGridLoader} /> */}
                                {/* <Table responsive>
                                    <thead>
                                        <tr>
                                        <th>#</th>
                                        <th>VehNo</th>
                                        <th>DrvNo</th>
                                        <th style={{width:300}}>DispatchTime</th>
                                        <th>OfferStatus</th>
                                        <th>LastResponseTime</th>
                                        <th>IsAgileTrip</th>
                                        <th>VehicleBidRank</th>
                                        <th>GotOffer</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {AgileDispatchGridResponse.map((Item, index) => (
                                            Item.VehNo == "" ? "" :
                                            <tr>
                                                <td>{index}</td>
                                                <td>{Item.VehNo}</td>
                                                <td>{Item.DrvNo}</td>
                                                <td>{Item.DispatchTime}</td>
                                                <td>{Item.OfferStatus}</td>
                                                <td>{Item.LastResponseTime}</td>
                                                <td>{Item.IsAgileTrip == true? "true" : "false"}</td>
                                                <td>{Item.VehicleBidRank}</td>
                                                <td>{Item.GotOffer == true? "true" : "false"}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </Form.Group>
                        </Container> */}
                    </Modal.Body>
                    {/* <Modal.Footer>
                        <Button className="tripaction_btn_color" onClick={false}>
                            Send Link
                        </Button>
                        <Button variant="secondary" onClick={handleAgileDispatchDialogClose}>
                            Cancel
                        </Button>
                    </Modal.Footer> */}
                </Modal>:""}
            {displayNoDataAlert ? 
                <Modal centered show={displayNoDataAlert} onHide={handleAlertModalClose} backdrop="static" keyboard={true} animation={true}>
                    <Modal.Header className='noshow_dialog_header_bgcolor' style={{ height: "50px" }} closeButton>
                        <Modal.Title className='noshow_dialog_title_color user-select-none'>
                            {noDataAlert.alertTitle}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="user-select-none">
                    <b>
                    {noDataAlert.alertMsg.split('\\n').map((line, index) => (
                        <React.Fragment key={index}>
                        {line}
                        <br />
                        </React.Fragment>
                    ))}
                    </b>
                        {showShareLink?
                            <Row className="m-0 w-100 mt-2 justify-content-center">
                                <Col>
                                    <input type="text" className="px-1 rounded border border-secondary mx-3" onInput={(e)=>{e.target.value = e.target.value.replace(/[^0-9-]*$/g, '').replace(/(\..*?)\..*/g, '$1');}} onChange={(e)=>{setCustomerPhone(e.target.value)}} value={customerPhone} style={{width:"140px"}} placeholder="Customer Phone"/>
                                    <Button className="activate_btn_ok border-0 mx-1" onClick={()=>{navigator.clipboard.writeText("http://reservation.mars.itcurves.us/VehicleTracker.aspx?ConfirmationNo="+String(confirmationNo)+"&TspID="+String(TSPID))}}>
                                        <Icon icon="bx:copy" className='d-inline-flex mx-1' style={{color:"white"}}/> 
                                        {"Copy Link"}
                                    </Button>
                                    <Button className="activate_btn_ok border-0 mx-1" onClick={handleSendShareLinkToCustomer}>
                                        <Icon icon="bx:paper-plane" className='d-inline-flex mx-1' style={{color:"white"}}/> 
                                        {"Send Link"}
                                    </Button>
                                    {showSharedLinkConfirmation? 
                                        <Row>
                                            <Col className="text-center">
                                                <p className="small m-0 text-primary">{"A link for tracking the ride has been shared with the customer."}</p>
                                            </Col>
                                        </Row>
                                    :""}
                                </Col>
                            </Row>
                        :""}
                    </Modal.Body>
                    {noDataAlert.btnFlag? 
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleAlertModalClose}>
                                OK
                            </Button>
                        </Modal.Footer>
                    :""}
                    {noDataAlert.ShowYesNoBtn? 
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleAgileDispatchDialogClose}>
                                Yes
                            </Button>
                            <Button variant="secondary" onClick={handleAlertModalClose}>
                                No
                            </Button>
                        </Modal.Footer>
                    :""}
                </Modal>:""}
        </>

    );
}

export default AgileDispatch;